<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener("DOMContentLoaded", function() {
  var LLimg = document.querySelectorAll("img.lazyloaded");
  for (let i=0; i<5; i++){
    LLimg[i].setAttribute("loading", "eager");
    LLimg[i].classList.remove("lazyloaded");
  }
});
